import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-6bddd5d8")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "List of tools", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Spotify tools", -1)
const _hoisted_3 = { class: "tool-list" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "tool-item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tool-header" }, "Randomize playlist order"),
  /*#__PURE__*/_createElementVNode("p", { class: "tool-body" }, " Randomizes the order of a playlist in place, permanently, unlike simply shuffling the playlist. This affects the default ordering of a playlist. ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "(more tools coming soon 🙂)", -1)
const _hoisted_6 = {
  key: 1,
  class: "warn"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", null, "Last.fm tools", -1)
const _hoisted_8 = {
  key: 2,
  class: "tool-list"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "tool-item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tool-header" }, "Top artists chart"),
  /*#__PURE__*/_createElementVNode("p", { class: "tool-body" }, "Chart visualization of your listening history")
], -1)
const _hoisted_10 = {
  key: 3,
  class: "warn"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    (_ctx.spotifyUser)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_link, { to: "/tools/shuffle" }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _hoisted_5
        ], 64))
      : (_openBlock(), _createElementBlock("p", _hoisted_6, "You aren't signed in to Spotify.")),
    _hoisted_7,
    (_ctx.lastfmUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_router_link, { to: "/tools/artists" }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_10, "You haven't set your Last.fm username."))
  ], 64))
}